import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';

// SSO
import ssoReducer from '../slices/ssoSlice';

// Core
import countiesReducer from '../slices/countiesSlice';
import userReducer from '../slices/userSlice';
import winnersReducer from '../slices/winnersSlice';
import claimPrizeSlice from '../slices/claimPrizeSlice';

export const store = configureStore({
    reducer: {
        sso: ssoReducer,
        counties: countiesReducer,
        users: userReducer,
        winners: winnersReducer,
        claimPrize: claimPrizeSlice
    }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
    ReturnType,
    RootState,
    unknown,
    Action<string>
>;
